import { Product } from '../../types/Product';

interface NutritionalInfo {
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
  fiber: number;
}

// Estimated nutritional values per 100g for different food categories
const nutritionalEstimates: Record<string, NutritionalInfo> = {
  'carne': { calories: 250, protein: 25, carbs: 0, fat: 15, fiber: 0 },
  'pescado': { calories: 150, protein: 20, carbs: 0, fat: 8, fiber: 0 },
  'verdura': { calories: 35, protein: 2, carbs: 7, fat: 0, fiber: 3 },
  'fruta': { calories: 60, protein: 1, carbs: 15, fat: 0, fiber: 2 },
  'pasta': { calories: 350, protein: 12, carbs: 70, fat: 2, fiber: 3 },
  'arroz': { calories: 330, protein: 7, carbs: 75, fat: 1, fiber: 1 },
  'legumbre': { calories: 340, protein: 21, carbs: 60, fat: 2, fiber: 15 }
};

export const calculateNutritionalInfo = (products: Product[]): string => {
  let totalNutrition: NutritionalInfo = {
    calories: 0,
    protein: 0,
    carbs: 0,
    fat: 0,
    fiber: 0
  };

  products.forEach(product => {
    const category = Object.keys(nutritionalEstimates).find(cat => 
      product.category_name.toLowerCase().includes(cat)
    );

    if (category) {
      const baseNutrition = nutritionalEstimates[category];
      // Estimate portion size based on price (rough approximation)
      const estimatedGrams = product.current_price * 100;
      
      totalNutrition.calories += (baseNutrition.calories * estimatedGrams) / 100;
      totalNutrition.protein += (baseNutrition.protein * estimatedGrams) / 100;
      totalNutrition.carbs += (baseNutrition.carbs * estimatedGrams) / 100;
      totalNutrition.fat += (baseNutrition.fat * estimatedGrams) / 100;
      totalNutrition.fiber += (baseNutrition.fiber * estimatedGrams) / 100;
    }
  });

  return `## Información Nutricional (por ración)

- Calorías: ${Math.round(totalNutrition.calories / 4)} kcal
- Proteínas: ${Math.round(totalNutrition.protein / 4)}g
- Carbohidratos: ${Math.round(totalNutrition.carbs / 4)}g
- Grasas: ${Math.round(totalNutrition.fat / 4)}g
- Fibra: ${Math.round(totalNutrition.fiber / 4)}g

*Valores aproximados por ración (4 raciones por receta)`;
};